import {formatMoney} from '@shopify/theme-currency';
import FlickityFade from 'flickity-fade';

import hideElement from '../util/hide-element';
import showElement from '../util/show-element';
import scrollTo from '../util/scroll-to';
import {ProductFormReader} from '../vendor/theme-scripts/theme-product-form';
import {isDesktop} from '../util/media-query';

import {InitSlider} from '../media/init-slider';
import Zoom from "../media/zoom";

import SelloutVariants from './product-form-sellout';
import * as themeCurrency from '@shopify/theme-currency';

const selectors = {
  product: '[data-product]',
  productForm: '[data-product-form]',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  formWrapper: '[data-form-wrapper]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productSlideshow: '[data-product-slideshow]',
  productImage: '[data-product-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  unitPrice: '[data-product-unit-price]',
  unitBase: '[data-product-base]',
  unitWrapper: '[data-product-unit]',
  isPreOrder: '[data-product-preorder]',
  sliderEnabled: 'flickity-enabled',
  productSlide: '.product__slide',
  subPrices: '[data-subscription-watch-price]',
  subSelectors: '[data-subscription-selectors]',
  subsToggle: '[data-toggles-group]',
  subsChild: 'data-group-toggle',
  subDescription: '[data-plan-description]',
  section: '[data-section-type]',
  quickAddModal: '[data-quick-add-modal]',
  priceOffWrap: '[data-price-off]',
  priceOffType: '[data-price-off-type]',
  priceOffAmount: '[data-price-off-amount]',
  remainingCount: '[data-remaining-count]',
  remainingMax: '[data-remaining-max]',
  remainingWrapper: '[data-remaining-wrapper]',
  remainingJSON: '[data-product-remaining-json]',
  optionValue: '[data-option-value]',
  optionPosition: '[data-option-position]',
  installment: '[data-product-form-installment]',
  inputId: 'input[name="id"]',
};

const classes = {
  hidden: 'hidden',
  variantSoldOut: 'variant--soldout',
  variantUnavailable: 'variant--unavailable',
  productPriceSale: 'product__price--sale',
  remainingLow: 'count-is-low',
  remainingIn: 'count-is-in',
  remainingOut: 'count-is-out',
  remainingUnavailable: 'count-is-unavailable',
};

const attributes = {
  dataTallLayout: 'data-tall-layout',
  remainingMaxAttr: 'data-remaining-max',
  dataEnableHistoryState: 'data-enable-history-state',
  optionPosition: 'data-option-position',
  dataImageId: 'data-image-id',
  quickAddButton: 'data-quick-add-btn',
  enableImageZoom: 'data-image-zoom-enable',
  enableVariantGallery: 'data-variant-gallery-enable',
  gwpBtnText: 'data-change-gwp-text'
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cartAddEvents();

    this.container = this.closest(selectors.section) || this.closest(selectors.quickAddModal);
    if (!this.container) return;

    this.sectionId = this.container.dataset.sectionId;
    this.tallLayout = this.container.getAttribute(attributes.dataTallLayout) === 'true';
    this.product = this.container.querySelector(selectors.product);
    this.productForm = this.container.querySelector(selectors.productForm);
    this.installmentForm = this.container.querySelector(selectors.installment);
    this.sellout = null;

    this.priceOffWrap = this.container.querySelector(selectors.priceOffWrap);
    this.priceOffAmount = this.container.querySelector(selectors.priceOffAmount);
    this.priceOffType = this.container.querySelector(selectors.priceOffType);
    this.planDescription = this.container.querySelector(selectors.subDescription);

    this.remainingWrapper = this.container.querySelector(selectors.remainingWrapper);

    if (this.remainingWrapper) {
      const remainingMaxWrap = this.container.querySelector(selectors.remainingMax);
      if (remainingMaxWrap) {
        this.remainingMaxInt = parseInt(remainingMaxWrap.getAttribute(attributes.remainingMaxAttr), 10);
        this.remainingCount = this.container.querySelector(selectors.remainingCount);
        this.remainingJSONWrapper = this.container.querySelector(selectors.remainingJSON);
        this.remainingJSON = null;

        if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== '') {
          this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
        } else {
          console.warn('Missing product quantity JSON');
        }
      }
    }

    this.enableHistoryState = this.container.getAttribute(attributes.dataEnableHistoryState) === 'true';
    this.hasUnitPricing = this.container.querySelector(selectors.unitWrapper);
    this.subSelectors = this.container.querySelector(selectors.subSelectors);
    this.subPrices = this.container.querySelector(selectors.subPrices);
    this.isPreOrder = this.container.querySelector(selectors.isPreOrder);

    let productJSON = null;
    const productElemJSON = this.container.querySelector(selectors.productJson);
    if (productElemJSON) {
      productJSON = productElemJSON.innerHTML;
    }
    if (productJSON) {
      this.productJSON = JSON.parse(productJSON);
      this.linkForm();
      this.sellout = new SelloutVariants(this.container, this.productJSON);
    } else {
      console.error('Missing product JSON');
    }
  }

  cartAddEvents() {
    this.buttonATC = this.querySelector(selectors.addToCart);
    if (!this.buttonATC) return;

    this.buttonATC.addEventListener('click', (e) => {
      e.preventDefault();

      const isGwpChangeForm = this.hasAttribute('data-gwp-change-form');
      const isBundle = this.hasAttribute('data-product-form-bundle');
      const isBundleEdit = this.hasAttribute('data-bundle-edit-form');

      if (isGwpChangeForm) {
        const data = {
          id: this.getAttribute('data-gwp-change-form'),
          quantity: 0
        }

        fetch(theme.routes.cart_change_url, {
          method: 'post',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            if (!parsedState.errors) {
              document.dispatchEvent(
                new CustomEvent('theme:cart:add', {
                  detail: {
                    button: this.buttonATC,
                  },
                  bubbles: false,
                })
              );
            }
          })

      } else if (isBundleEdit) {
        let data = {};
        const _this = this;

        let removeDataBundle = JSON.parse(this.getAttribute('data-bundle-edit-form'));
        Object.keys(removeDataBundle).forEach(key => removeDataBundle[key] = 0);
        data = {
          updates: removeDataBundle
        }

        fetch(theme.routes.cart_update_url, {
          method: 'post',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            if (!parsedState.errors) {
              _this.addBundleToCart(true);
            }
          })
      } else if (isBundle) {
        this.addBundleToCart();

      } else {
        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: this.buttonATC,
            },
            bubbles: false,
          })
        );
      }
    });
  }

  addBundleToCart(isBundleEdit = false) {
    const formWrapper = this.closest('[data-form-wrapper]')
    if (!formWrapper) return
    const bundleProdInputs = Array.from(formWrapper.querySelectorAll('input[data-bundle-product-id]'));
    const quantity = isBundleEdit ? +this.getAttribute('data-bundle-edit-form-quantity') || 1 : formWrapper.querySelector('input[name="quantity"]').value
    const bundleItem = formWrapper.querySelector('bundle-item');
    const bundleId = 'bundle-' + bundleProdInputs.map(item =>  item.value).join('|');
    const bundleData = JSON.parse(bundleItem.getAttribute('data-bundle-data'));

    let formData = {'items': []};

    bundleProdInputs.forEach((input, index) => {
      formData.items.push({
        "id": input.value,
        "quantity": quantity,
        "properties": {
          "_is_bundle": "true",
          "_bundle_id": bundleId,
          "_is_first_item_in_bundle": index === 0,
          "_bundle_url": bundleData.url,
          "_bundle_image_url": bundleData.imageUrl,
          "_bundle_title": bundleData.title,
          "_bundle_handle": bundleData.handle,
          "_bundle_item_index": index
        }
      })
    });

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          formData: formData,
          button: this.buttonATC
        },
        bubbles: false
      })
    );
  }

  destroy() {
    this.productForm.destroy();
  }

  linkForm() {
    this.productForm = new ProductFormReader(this.container, this.productJSON, {
      onOptionChange: this.onOptionChange.bind(this),
      onPlanChange: this.onPlanChange.bind(this),
    });
    this.pushState(this.productForm.getFormState(), true);
    this.subsToggleListeners();
  }

  onOptionChange(evt) {
    this.pushState(evt.dataset);
    this.updateProductImage(evt);
  }

  onPlanChange(evt) {
    if (this.subPrices) {
      this.pushState(evt.dataset);
    }
  }

  pushState(formState, init = false) {
    this.productState = this.setProductState(formState);
    this.updateAddToCartState(formState);
    this.updateProductPrices(formState);
    this.updateSaleText(formState);
    this.updateSubscriptionText(formState);
    this.updateRemaining(formState);
    this.updateLegend(formState);
    this.fireHookEvent(formState);
    this.sellout?.update(formState);
    if (this.container.hasAttribute(attributes.enableVariantGallery)) {
     this.updateContent(formState);
    }
    if (this.enableHistoryState && !init) {
      this.updateHistoryState(formState);
    }
  }

  updateAddToCartState(formState) {
    const variant = formState.variant;
    let addText = theme.strings.addToCart;
    const priceWrapper = this.container.querySelectorAll(selectors.priceWrapper);
    const addToCart = this.container.querySelectorAll(selectors.addToCart);
    const addToCartText = this.container.querySelectorAll(selectors.addToCartText);
    const formWrapper = this.container.querySelectorAll(selectors.formWrapper);

    if (this.installmentForm && variant) {
      const installmentInput = this.installmentForm.querySelector(selectors.inputId);
      installmentInput.value = variant.id;
      installmentInput.dispatchEvent(new Event('change', {bubbles: true}));
    }

    if (this.isPreOrder) {
      addText = theme.strings.preOrder;
    }

    if (priceWrapper.length && variant) {
      priceWrapper.forEach((element) => {
        element.classList.remove(classes.hidden);
      });
    }

    if (addToCart.length) {
      addToCart.forEach((element) => {
        if (element.hasAttribute(attributes.quickAddButton)) return;

        if (variant) {
          if (variant.available) {
            element.disabled = false;
          } else {
            element.disabled = true;
          }
        } else {
          element.disabled = true;
        }
      });
    }

    if (addToCartText.length) {
      addToCartText.forEach((element) => {
        element.hasAttribute(attributes.gwpBtnText) ? addText = theme.strings.changeOptionGwp : addText = theme.strings.addToCart
        if (variant) {
          if (variant.available) {
            element.innerHTML = addText;
          } else {
            element.innerHTML = theme.strings.soldOut;
          }
        } else {
          element.innerHTML = theme.strings.unavailable;
        }
      });
    }

    if (formWrapper.length) {
      formWrapper.forEach((element) => {
        if (variant) {
          if (variant.available) {
            element.classList.remove(classes.variantSoldOut, classes.variantUnavailable);
          } else {
            element.classList.add(classes.variantSoldOut);
            element.classList.remove(classes.variantUnavailable);
          }

          const formSelect = element.querySelector(selectors.originalSelectorId);
          if (formSelect) {
            formSelect.value = variant.id;
          }

          const inputId = element.querySelector(`${selectors.inputId}[form]`);
          if (inputId) {
            inputId.value = variant.id;
            inputId.dispatchEvent(new Event('change'));
          }
        } else {
          element.classList.add(classes.variantUnavailable);
          element.classList.remove(classes.variantSoldOut);
        }
      });
    }
  }

  updateHistoryState(formState) {
    const variant = formState.variant;
    const plan = formState.plan;
    const location = window.location.href;
    if (variant && location.includes('/product')) {
      const url = new window.URL(location);
      const params = url.searchParams;
      params.set('variant', variant.id);
      if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
        params.set('selling_plan', plan.detail.id);
      } else {
        params.delete('selling_plan');
      }
      url.search = params.toString();
      const urlString = url.toString();
      window.history.replaceState({path: urlString}, '', urlString);
    }
  }

  updateRemaining(formState) {
    const variant = formState.variant;

    this.remainingWrapper?.classList.remove(classes.remainingIn, classes.remainingOut, classes.remainingUnavailable, classes.remainingLow);

    if (variant && this.remainingWrapper && this.remainingJSON) {
      const remaining = this.remainingJSON[variant.id];

      if (remaining === 'out' || remaining < 1) {
        this.remainingWrapper.classList.add(classes.remainingOut);
      }

      if (remaining === 'in' || remaining >= this.remainingMaxInt) {
        this.remainingWrapper.classList.add(classes.remainingIn);
      }
      if (remaining === 'low' || (remaining > 0 && remaining < this.remainingMaxInt)) {
        this.remainingWrapper.classList.add(classes.remainingLow);

        if (this.remainingCount) {
          this.remainingCount.innerHTML = remaining;
        }
      }
    } else if (!variant && this.remainingWrapper) {
      this.remainingWrapper.classList.add(classes.remainingUnavailable);
    }
  }

  getBaseUnit(variant) {
    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
  }

  subsToggleListeners() {
    const toggles = this.container.querySelectorAll(selectors.subsToggle);

    toggles.forEach((toggle) => {
      toggle.addEventListener(
        'change',
        function (e) {
          const val = e.target.value.toString();
          const selected = this.container.querySelector(`[${selectors.subsChild}="${val}"]`);
          const groups = this.container.querySelectorAll(`[${selectors.subsChild}]`);
          if (selected) {
            selected.classList.remove(classes.hidden);
            const first = selected.querySelector(`[name="selling_plan"]`);
            first.checked = true;
            first.dispatchEvent(new Event('change'));
          }
          groups.forEach((group) => {
            if (group !== selected) {
              group.classList.add(classes.hidden);
              const plans = group.querySelectorAll(`[name="selling_plan"]`);
              plans.forEach((plan) => {
                plan.checked = false;
                plan.dispatchEvent(new Event('change'));
              });
            }
          });
        }.bind(this)
      );
    });
  }

  updateSaleText(formState) {
    if (this.productState.planSale) {
      this.updateSaleTextSubscription(formState);
    } else if (this.productState.onSale) {
      this.updateSaleTextStandard(formState);
    } else if (this.priceOffWrap) {
      this.priceOffWrap.classList.add(classes.hidden);
    }
  }

  updateSaleTextStandard(formState) {
    if (this.priceOffType) {
      this.priceOffType.innerHTML = window.theme.strings.sale || 'sale';
    }

    if (this.priceOffAmount && this.priceOffWrap) {
      const variant = formState.variant;
      /* custom start my */
      const productJsonScript1 = this.container.querySelector(selectors.productJson);
      const productJsonContent1 = productJsonScript1.textContent.trim();
      const productData1 = JSON.parse(productJsonContent1);
      const productTags1 = productData1.tags;
      const formattedTags1 = productTags1.join(',');
      var tagsArray1 = formattedTags1.split(',');
      var spgper1 = '';
      var spgperdis1 = '';
      var discountFloat='';
      let foundDiscount1 = false;
      tagsArray1.forEach(function(tag) {
        if (tag.includes('DISCOUNT-')) {
          var myArro = tag.split("-");
          if (myArro[1] !== undefined && myArro[2] !== undefined) {
            spgper1 = myArro[1].trim();
            spgperdis1 = myArro[2].trim();

            if (variant.id == spgper1) {
              var newspgprice1 = parseFloat(variant.price) - ((parseFloat(variant.price) * spgperdis1) / 100);
              // price1 = newspgprice1;
              discountFloat = (variant.compare_at_price - newspgprice1) / variant.compare_at_price;
              foundDiscount1 = true;
              return;
            }
          }else if (myArro[1] !== undefined) {
            // Case 2: Apply a general discount for all variants
            var generalDiscount = parseFloat(myArro[1].trim());
            var newGeneralPrice = parseFloat(variant.price) - ((parseFloat(variant.price) * generalDiscount) / 100);
            discountFloat = (variant.compare_at_price - newGeneralPrice) / variant.compare_at_price;
            foundDiscount1 = true;
            return;
          }
        }
      });

      if (!foundDiscount1) {
        discountFloat = (variant.compare_at_price - variant.price) / variant.compare_at_price;
      }
      /* custom end my */
      // const discountFloat = (variant.compare_at_price - variant.price) / variant.compare_at_price;
      const discountInt = Math.floor(discountFloat * 100);
      this.priceOffAmount.innerHTML = `${discountInt}%`;
      this.priceOffWrap.classList.remove(classes.hidden);
    }
  }

  updateSubscriptionText(formState) {
    if (formState.plan && this.planDescription) {
      this.planDescription.innerHTML = formState.plan.detail.description;
      this.planDescription.classList.remove(classes.hidden);
    } else if (this.planDescription) {
      this.planDescription.classList.add(classes.hidden);
    }
  }

  updateSaleTextSubscription(formState) {
    if (this.priceOffType) {
      this.priceOffType.innerHTML = window.theme.strings.subscription || 'subscripton';
    }

    if (this.priceOffAmount && this.priceOffWrap) {
      const adjustment = formState.plan.detail.price_adjustments[0];
      const discount = adjustment.value;
      if (adjustment && adjustment.value_type === 'percentage') {
        this.priceOffAmount.innerHTML = `${discount}%`;
      } else {
        this.priceOffAmount.innerHTML = formatMoney(discount, theme.moneyFormat);
      }
      this.priceOffWrap.classList.remove(classes.hidden);
    }
  }

  updateProductPrices(formState) {
    const productJsonScript = this.container.querySelector(selectors.productJson);
    const productJsonContent = productJsonScript.textContent.trim();
    const productData = JSON.parse(productJsonContent);
    const productTags = productData.tags;
    const formattedTags = productTags.join(',');

    //  var protags = formattedTags;
    var tagsArray = formattedTags.split(',');
    var spgper = '';
    var spgperdis = '';
    const variant = formState.variant;
    const plan = formState.plan;
    const priceWrappers = this.container.querySelectorAll(selectors.priceWrapper);

    priceWrappers.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector(selectors.comparePrice);
      const productPriceEl = wrap.querySelector(selectors.productPrice);
      const comparePriceText = wrap.querySelector(selectors.comparePriceText);

      let comparePrice = '';
      let price = '';

      if (this.productState.available) {
        comparePrice = variant.compare_at_price;
        let foundDiscount = false;

        tagsArray.forEach(function(tag) {
          if (tag.includes('DISCOUNT-')) {
            var myArr = tag.split("-");
            if (myArr[1] !== undefined && myArr[2] !== undefined) {
              spgper = myArr[1].trim();
              spgperdis = myArr[2].trim();
              //console.log("ggg" + spgperdis);

              if (variant.id == spgper) {
                var newspgprice = parseFloat(variant.price) - ((parseFloat(variant.price) * spgperdis) / 100);
                price = newspgprice;
                document.querySelector('.custom-set').style.display = 'inline-block';
                document.querySelector('.tagoffprice').style.display = 'inline-block';
                document.querySelector('.tagoffprice').innerHTML = spgperdis+'% OFF';
                var productpricestriElement = document.querySelector('.product__price--strike');
                var productpriofElement = document.querySelector('.product__price--off');
                if(productpricestriElement){
                  productpricestriElement.style.display = 'none';
                }
                if(productpriofElement){
                  productpriofElement.style.display = 'none';
                }
                var customSetElementsalet = document.querySelector('.product__price--sale-tag');
                if (customSetElementsalet) {
                  customSetElementsalet.classList.add('saletagesdis');
                }

                document.querySelector('.custom-set').innerHTML = themeCurrency.formatMoney(variant.price, theme.moneyFormat);
                foundDiscount = true;
                return; // Break out of the forEach loop
              }
            } else if (myArr[1] !== undefined) {
              // Case 2: Apply a general discount for all variants
              var generalDiscount = parseFloat(myArr[1].trim());
              var newGeneralPrice = parseFloat(variant.price) - ((parseFloat(variant.price) * generalDiscount) / 100);
              price = newGeneralPrice;
              document.querySelector('.custom-set').style.display = 'inline-block';
              document.querySelector('.tagoffprice').style.display = 'inline-block';
              document.querySelector('.tagoffprice').innerHTML = generalDiscount+'% OFF';
              document.querySelector('.custom-set').innerHTML = themeCurrency.formatMoney(variant.price, theme.moneyFormat);
              var productpricestriElement = document.querySelector('.product__price--strike');
              var productpriofElement = document.querySelector('.product__price--off');
              if(productpricestriElement){
                productpricestriElement.style.display = 'none';
              }
              if(productpriofElement){
                productpriofElement.style.display = 'none';
              }
              var customSetElementsalet = document.querySelector('.product__price--sale-tag');
              if (customSetElementsalet) {
                customSetElementsalet.classList.add('saletagesdis');
              }
              foundDiscount = true;
              return; // Break out of the forEach loop
            }
          }
        });

        if (!foundDiscount) {
          price = variant.price;
          var customSetElement = document.querySelector('.custom-set');
          var tagoffpriceElement = document.querySelector('.tagoffprice');
          if(customSetElement){
            customSetElement.style.display = 'none';
          }
          if(tagoffpriceElement){
            tagoffpriceElement.style.display = 'none';
          }
          var productpricestriElement = document.querySelector('.product__price--strike');
          var productpriofElement = document.querySelector('.product__price--off');
          if(productpricestriElement){
            productpricestriElement.style.display = 'inline-block';
          }
          if(productpriofElement){
            productpriofElement.style.display = 'inline-block';
          }
          var customSetElementsalet = document.querySelector('.product__price--sale-tag');
          if (customSetElementsalet) {
            customSetElementsalet.classList.remove('saletagesdis');
          }
        }
      }

      /*  if (this.productState.available) {
          comparePrice = variant.compare_at_price;
          tagsArray.forEach(function(tag) {
            if (tag.includes('DISCOUNT-')) {
                var myArr = tag.split("-");
               if (myArr[1] !== undefined && myArr[2] !== undefined) {
                  spgper = myArr[1].trim();
                  spgperdis = myArr[2].trim();
                 console.log("ggg"+variant.id);
                if(variant.id == spgper){
                  var newspgprice = parseFloat(variant.price) - ((parseFloat(variant.price) * spgperdis)/100);
                  price = newspgprice;
                }

              }
            }
        });
        if (price === undefined) {
              price = variant.price;
          }
        }*/

      if (this.productState.hasPlan) {
        price = plan.allocation.price;
      }

      if (this.productState.planSale) {
        comparePrice = plan.allocation.compare_at_price;
        price = plan.allocation.price;
      }

      if (comparePriceEl) {
        if (this.productState.onSale || this.productState.planSale) {
          comparePriceEl.classList.remove(classes.hidden);
          comparePriceText.classList.remove(classes.hidden);
          productPriceEl.classList.add(classes.productPriceSale);
        } else {
          comparePriceEl.classList.add(classes.hidden);
          comparePriceText.classList.add(classes.hidden);
          productPriceEl.classList.remove(classes.productPriceSale);
        }
        comparePriceEl.innerHTML = formatMoney(comparePrice, theme.moneyFormat);
      }

      productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : formatMoney(price, theme.moneyFormat);
    });

    if (this.hasUnitPricing) {
      this.updateProductUnits(formState);
    }
  }

  updateProductUnits(formState) {
    const variant = formState.variant;
    const plan = formState.plan;
    let unitPrice = null;

    if (variant && variant.unit_price) {
      unitPrice = variant.unit_price;
    }
    if (plan && plan.allocation && plan.allocation.unit_price) {
      unitPrice = plan.allocation.unit_price;
    }

    if (unitPrice) {
      const base = this.getBaseUnit(variant);
      const formattedPrice = formatMoney(unitPrice, theme.moneyFormat);
      this.container.querySelector(selectors.unitPrice).innerHTML = formattedPrice;
      this.container.querySelector(selectors.unitBase).innerHTML = base;
      showElement(this.container.querySelector(selectors.unitWrapper));
    } else {
      hideElement(this.container.querySelector(selectors.unitWrapper));
    }
  }

  fireHookEvent(formState) {
    const variant = formState.variant;
    this.container.dispatchEvent(
      new CustomEvent('theme:variant:change', {
        detail: {
          variant: variant,
        },
        bubbles: true,
      })
    );
  }

  /**
   * Tracks aspects of the product state that are relevant to UI updates
   * @param {object} evt - variant change event
   * @return {object} productState - represents state of variant + plans
   *  productState.available - current variant and selling plan options result in valid offer
   *  productState.soldOut - variant is sold out
   *  productState.onSale - variant is on sale
   *  productState.showUnitPrice - variant has unit price
   *  productState.requiresPlan - all the product variants requires a selling plan
   *  productState.hasPlan - there is a valid selling plan
   *  productState.planSale - plan has a discount to show next to price
   *  productState.planPerDelivery - plan price does not equal per_delivery_price - a prepaid subscription
   */
  setProductState(dataset) {
    const variant = dataset.variant;
    const plan = dataset.plan;

    const productState = {
      available: true,
      soldOut: false,
      onSale: false,
      showUnitPrice: false,
      requiresPlan: false,
      hasPlan: false,
      planPerDelivery: false,
      planSale: false,
    };

    if (!variant || (variant.requires_selling_plan && !plan)) {
      productState.available = false;
    } else {
      if (!variant.available) {
        productState.soldOut = true;
      }

      if (variant.compare_at_price > variant.price) {
        productState.onSale = true;
      }

      if (variant.unit_price) {
        productState.showUnitPrice = true;
      }

      if (this.product && this.product.requires_selling_plan) {
        productState.requiresPlan = true;
      }

      if (plan && this.subPrices) {
        productState.hasPlan = true;
        if (plan.allocation.per_delivery_price !== plan.allocation.price) {
          productState.planPerDelivery = true;
        }
        if (variant.price > plan.allocation.price) {
          productState.planSale = true;
        }
      }
    }
    return productState;
  }

  updateProductImage(evt) {
    const variant = evt.dataset.variant;

    if (variant) {
      // Update variant image, if one is set
      if (variant.featured_media) {
        const newImg = this.container.querySelector(`[${attributes.dataImageId}="${variant.featured_media.id}"]`);
        const newImageParent = newImg?.closest(selectors.productSlide);
        // If we have a mobile breakpoint or the tall layout is disabled,
        // just switch the slideshow.

        if (newImageParent) {
          const newImagePos = Array.from(newImageParent.parentElement.children).indexOf(newImageParent);
          const slider = this.container.querySelector(selectors.productSlideshow);
          const isDesktopView = isDesktop();

          if (slider && slider.classList.contains(selectors.sliderEnabled)) {
            FlickityFade.data(slider).select(newImagePos);
          } else if (slider && !isDesktopView) {
            slider.scrollTo({
              top: 0,
              left: newImageParent.offsetLeft,
              behavior: 'smooth',
            });
          }

          if (isDesktopView && this.tallLayout) {
            // We know its a tall layout, if it's sticky
            // scroll to the images
            // Scroll to/reorder image unless it's the first photo on load
            const newImgTop = newImg.getBoundingClientRect().top;

            if (newImagePos === 0 && newImgTop + window.scrollY > window.pageYOffset) return;

            // Scroll to variant image
            document.dispatchEvent(
              new CustomEvent('theme:tooltip:close', {
                bubbles: false,
                detail: {
                  hideTransition: false,
                },
              })
            );

            scrollTo(newImgTop);
          }
        }
      }
    }
  }

  updateLegend(formState) {
    const variant = formState.variant;
    if (variant) {
      const optionValues = this.container.querySelectorAll(selectors.optionValue);
      if (optionValues.length) {
        optionValues.forEach((optionValue) => {
          const selectorWrapper = optionValue.closest(selectors.optionPosition);
          if (selectorWrapper) {
            const optionPosition = selectorWrapper.getAttribute(attributes.optionPosition);
            const optionIndex = parseInt(optionPosition, 10) - 1;
            const selectedOptionValue = variant.options[optionIndex];
            optionValue.innerHTML = selectedOptionValue;
          }
        });
      }
    }
  }

  updateContent(formState) {
    const variantID = formState.variant.id;
    const location =  window.location.href;
    if (variantID && !location.includes(variantID) ) {
      fetch(`${window.location.pathname}?variant=${variantID}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const selectors = {
            slider: '.product__images',
            ingredients: '.product__ingredients'
          }
          const selectorsValues = Object.values(selectors);
          selectorsValues.forEach((item) => {
              let destination = document.querySelector(item);
              let source = html.querySelector(item);
              if (source && destination) destination.innerHTML = source.innerHTML;
            }
          )

          new InitSlider(null, this.container);
          if (this.container.hasAttribute(attributes.enableImageZoom)) {
            new Zoom(null, this.container);
          }
        });
    }
  }
}

export {ProductForm};
